import {TOGGLE_PAUSE_MODAL} from "../../actions/actionTypes";

const initialState = {
    isOpen : false ,
    data : localStorage.getItem('isDark')===null ?
        (window.matchMedia("(prefers-color-scheme: dark)") &&  !document.body.classList.contains('lightMode') )
        || (window.matchMedia("(prefers-color-scheme: light)") &&  document.body.classList.contains('darkMode') )
        : Boolean(localStorage.getItem('isDark'))
    ,
    loading:false,
    error : null
}

export default function pauseModalReducer (state = initialState, action) {
    switch(action.type){
        case TOGGLE_PAUSE_MODAL:
            return {
                ...state ,
                isOpen : !state.isOpen
            }
        default: return state
    }
}

